var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPadlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.409,
    height: 13.879,
    viewBox: "0 0 10.409 13.879",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "padlock_1_",
    "data-name": "padlock (1)",
    d: "M12.108,5.2h-.434V3.47a3.47,3.47,0,0,0-6.939,0V5.2H4.3A1.3,1.3,0,0,0,3,6.506v6.072a1.3,1.3,0,0,0,1.3,1.3h7.807a1.3,1.3,0,0,0,1.3-1.3V6.506A1.3,1.3,0,0,0,12.108,5.2ZM5.891,3.47a2.313,2.313,0,1,1,4.626,0V5.2H5.891Zm2.891,6.2v1.317a.578.578,0,0,1-1.157,0V9.67a1.157,1.157,0,1,1,1.157,0Z",
    transform: "translate(-3)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.c49befd00bd20e9dccc122d4aa43e337.svg";
export { ForwardRef as ReactComponent };